<template>
    <div class="ourStoryBG">
        <el-row :gutter="20">
            <el-col :span="10" :offset="2">
                <el-card class="storyHidden entry">
                    <el-calendar v-model="value">
                        <template slot="dateCell" slot-scope="{date, data}">
                            <p :class="data.isSelected ? 'is-selected' : ''">
                                {{ data.day.split('-').slice(1)[1] }}<br>{{ data.isSelected ? '❤' : '' }}
                            </p>
                        </template>
                    </el-calendar>
                </el-card>
            </el-col>
            <el-col :span="10">
                <el-card class="storyHidden entry">
                    <el-calendar v-model="value2">
                        <template slot="dateCell" slot-scope="{date, data}">
                            <p :class="data.isSelected ? 'is-selected' : ''">
                                {{ data.day.split('-').slice(1)[1] }}<br>{{ data.isSelected ? '今天' : '' }}
                            </p>
                        </template>
                    </el-calendar>
                </el-card>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="20" :offset="2">
                <el-card class="storyHidden entry bottomCard">
                    <span class="title">嗨，
                        <span v-if="this.$userInfo.$userName === '杨小鱼'" class="yxyMark">杨小鱼</span>
                        <span v-if="this.$userInfo.$userName === '张小兔'" class="zxtMark">张小兔</span>
                        ，现在是你和
                        <span v-if="this.$userInfo.$userName === '杨小鱼'" class="zxtMark">张小兔</span>
                        <span v-if="this.$userInfo.$userName === '张小兔'" class="yxyMark">杨小鱼</span>
                        一起走过的第
                    </span>
                    <mark>
                        <span class="timer"><i class="el-icon-date"></i> {{ nowDate }}</span>
                    </mark>
                    <br>
                    <br>
                    <span class="title2">
                        一直在走的是时间，永远不变的是我们
                    </span>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>

export default {
    name: 'time',
    created() {
        
    },
    data() {
        return {
            value: null,
            value2: null,
            nowDate: "",
        }
    },
    beforeDestroy() {
        if (this.formatDate) {
            clearInterval(this.formatDate);
        }
    },
    mounted() {

        if(this.$userInfo.$userLimit === '') {
            this.$message({
                message:'不要乱来哦',
                type:'warning'
            });
            this.$router.push('/noZone');
        } else if (this.$userInfo.$userLimit > '1') { 
            this.$message({
                message:'不要乱来哦',
                type:'warning'
            });
            this.$router.push('/home');
        }

        this.value = new Date('2018-11-10 00:00:00');
        this.value2 = new Date();

        this.currentTime();
        this.cancelLoading();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('storyShow');
                }
            });
        })
        const hiddenElements = document.querySelectorAll('.storyHidden');
        hiddenElements.forEach((el) => observer.observe(el));
    },
    methods: {
        currentTime() {
            setInterval(this.formatDate, 500);
        },
        formatDate() {
            let date = new Date();
            let date2 = new Date(2018, 11, 10, 0, 0, 0, 0)
            let date3 = new Date(date - date2);
            let year = date3.getFullYear(); // 年
            let month = date3.getMonth() + 1; // 月
            let day = date3.getDate(); // 日
            let hour = date3.getHours(); // 时
            let minute = date3.getMinutes(); // 分
            let second = date3.getSeconds(); // 秒
            this.nowDate = `${year - 1970} 年 ${month} 个月 ${day} 天 ${hour} 小时 ${minute} 分钟 ${second} 秒`;
        },
        cancelLoading() {
            setTimeout(() => {
                this.loading = false;
            }, 500);
        },
    }
}
</script>


<style scoped lang="scss">
.bottomCard {
    margin-bottom: 20vh;
}

* {
    font-family: "HMOS_Regular"
}

/deep/ .el-calendar-table .el-calendar-day:hover {
    background-color: rgba(255, 155, 155, 0.103);
}

/deep/ .is-selected>.el-calendar-day {
    background-color: rgb(255, 235, 235);
}

/deep/ .is-selected>.el-calendar-day:hover {
    background-color: rgb(255, 241, 241);
}

.title {
    font-size: 18px;
    font-weight: 600;
}

.title2 {
    font-family: "HMOS_Regular";
    font-size: 20px;
    font-weight: 600;
}

.timer {
    font-family: "HMOS_Regular";
    font-size: 20px;
    font-weight: 600;
}

p {
    line-height: 2vh;
}

.el-card {
    margin-top: 2vh;
}

.is-selected {
    color: #ff6363;
    background-color: transparent;
    background-image: linear-gradient(#fc818984, #fc818984);
    background-repeat: no-repeat;
    background-size: 70% 50%;
    background-position: 50% 0%;
}

.zxtMark {
    background-color: transparent;
    background-image: linear-gradient(#ff6363, #ff6363);
    background-repeat: no-repeat;
    background-size: 100% 35%;
    background-position: 50% 100%;
}

.yxyMark {
    background-color: transparent;
    background-image: linear-gradient(#409eff, #409eff);
    background-repeat: no-repeat;
    background-size: 100% 35%;
    background-position: 50% 100%;
}

mark {
    color: #ff6363;
    background-color: transparent;
    background-image: linear-gradient(#fc818984, #fc818984);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: 50% 10%;
}

.content {
    font-family: "HMOS_Regular";
    font-size: 20px;
}

.el-icon-female {
    color: #ff6363;
}

.el-icon-male {
    color: #409eff;
}

.icon {
    font-size: 30px;
    font-weight: 600;
}

.name {
    font-family: 'HMOS_Regular';
    font-size: 35px;
}

.item {
    display: inline-block;
    margin: 0 auto;
    width: 50vw;
    margin-top: 2vh;
    height: auto;
    margin-bottom: 10px;
    text-align: center;
}

mark {
    background-color: transparent;
    color: inherit;
    background-image: linear-gradient(#b83e46b5, #b83e46b5);
    background-repeat: no-repeat;
    background-size: 100% 30%;
    background-position: 0 100%;
}

.card {
    margin-top: 5vh;
}

.ourStoryBG {
    /* background-color:#bfa; */
    width: 100%;
    height: 100%;
    text-align: center;
    overflow: auto;
}

.storyHidden {
    filter: blur(5px);
    transform: translateY(20%);
    opacity: 0;
    transition: all 1000ms;
}

.storyShow {
    filter: blur(0);
    transform: translateY(0);
    opacity: 1;
}

::-webkit-scrollbar {
    display: none;
}
</style>